import { Table, ColumnDefinition } from 'barte-design-system';
import { Skeleton } from '../skeleton';


import { TABLE_SKELETON_DEFAULT_ROW_COUNT } from './table-skeleton.constants';
import type { TableSkeletonProps } from './table-skeleton.type';

import styles from './table-skeleton.module.css';

export const TableSkeleton = <T extends Record<string, any>>({
    columns,
    data,
    rowKey,
    isLoading = false,
    rowCount = TABLE_SKELETON_DEFAULT_ROW_COUNT,
    ...rest
}: TableSkeletonProps<T>) => {

    const displayData = isLoading
        ? Array.from({ length: rowCount }).map((_, index) => ({ id: index } as unknown as T))
        : data;

    const displayColumns: ColumnDefinition<T>[] = isLoading
        ? columns.map(col => ({
            ...col,
            render: () => <Skeleton height="1rem" width="80%" />
        }))
        : columns;

    const displayRowKey = isLoading
        ? ((record: any) => record.id as string | number)
        : rowKey;

    const safeRest = isLoading
        ? { ...rest, onRowClick: undefined }
        : rest;

    return (
        <div className={styles['table-wrapper']}>
            <Table<T>
                {...safeRest}
                columns={displayColumns}
                data={displayData}
                rowKey={displayRowKey}
                className={styles.table}
            />
        </div >
    );
};
